// Mint-Settings-iPad · Cài đặt cá nhân (6 mục) — dữ liệu mẫu theo script board, chưa ghi DB.

export const PAD_SECS = [
  ['profile', 'Hồ sơ & ghế', '3 ghế'], ['look', 'Giao diện & ngôn ngữ', ''], ['noti', 'Thông báo', '7 loại'],
  ['backup', 'Backup & uỷ quyền', '2 đang có'], ['sessions', 'Phiên & thiết bị', '4 máy'], ['keys', 'Phím tắt bàn phím', ''],
] as const;
export type PadSec = (typeof PAD_SECS)[number][0];

export const PAD_NOTI: readonly { id: string; k: string; s: string; def: readonly [number, number, number]; locked?: boolean }[] = [
  { id: 'p0', k: 'Khẩn P0 · K1–K5, sự cố xe, cont lạnh', s: 'Luôn bật push + Zalo — không tắt được', def: [1, 1, 0], locked: true },
  { id: 'task', k: 'Việc tới hạn & quá hạn', s: 'Của tôi và người tôi đang thay', def: [1, 0, 1] },
  { id: 'appr', k: 'Duyệt chờ tôi', s: 'Release, margin, thanh toán, nghỉ phép', def: [1, 1, 1] },
  { id: 'mail', k: 'Mail gắn PIC cho tôi', s: 'info@ · support@', def: [1, 0, 0] },
  { id: 'vsl', k: 'Tàu đổi lịch / cut-off', s: 'Job tôi phụ trách', def: [1, 1, 0] },
  { id: 'debt', k: 'Công nợ quá hạn', s: 'Khách tôi phụ trách', def: [0, 0, 1] },
  { id: 'digest', k: 'Tóm tắt đầu ngày Ask HANA', s: '07:30 ngày làm việc', def: [1, 0, 1] },
];
export const PAD_CH = ['Push', 'Zalo', 'Email'] as const;

export const PAD_BACKUP: readonly (readonly [string, string, string])[] = [
  ['SALE-MGR', 'Duyệt margin, chuyển khách, release trong hạn mức', 'TUANNT'],
  ['BOD-DDIR', 'Duyệt cấp BOD', 'PHILIP'],
  ['Khách của tôi', '14 khách · job, báo giá, mail support@', 'ANDG'],
];
export const PAD_DELEG0: readonly (readonly [string, string])[] = [
  ['BOD-DDIR → PHILIP', '24/Oct/2026 08:00 → 25/Oct/2026 17:30 · nghỉ phép'],
  ['TUANNT (SALE-SE) → DAVID · 6 khách', '22–23/Oct/2026 · TUANNT vắng đột xuất'],
];
export const PAD_SESSIONS: readonly (readonly [string, string, boolean])[] = [
  ['Windows · Chrome 131', '235 Cộng Hòa · đang dùng trên máy khác', false],
  ['iPad Air · HANA Ezy', 'Máy này · TP.HCM', true],
  ['iPhone 15 · HANA Ezy', 'TP.HCM · 2 giờ trước · thiết bị chấm công', false],
  ['MacBook · Edge', 'Hà Nội · 6 ngày trước', false],
];
export const PAD_KEYS: readonly (readonly [string, string])[] = [
  ['Tìm nhanh mọi nơi', '⌘ K'], ['Tạo mới trên màn hiện tại', 'N'], ['Mở menu', '['],
  ['Đổi sáng / tối', '⌘ ⇧ L'], ['Mở Việc của tôi', 'G V'], ['Mở HANA Box', 'G B'],
];

/** Ô kênh thông báo: ô khoá P0 luôn bật; còn lại theo ghi đè rồi mặc định. */
export function padNotiOn(n: (typeof PAD_NOTI)[number], ci: number, ov: Readonly<Record<string, boolean>>): boolean {
  const base = n.def[ci] === 1;
  if (n.locked && base) return true;
  return ov[n.id + ci] ?? base;
}
